import { motion } from "framer-motion";

export const Slogan = () => {
  return (
    <section
      data-testid="slogan"
      className="relative py-24 md:py-36 px-6 md:px-12 lg:px-24 max-w-[1400px] mx-auto"
    >
      <div className="flex items-center gap-3 mb-8">
        <span className="h-px w-10 brand-gradient" />
        <span className="font-mono text-xs tracking-[0.25em] uppercase text-zinc-400">
          Mein Versprechen · IT, auf die Sie sich verlassen können
        </span>
      </div>

      <motion.h2
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-120px" }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className="font-display font-semibold tracking-tight leading-[1.02] text-4xl sm:text-5xl md:text-7xl lg:text-[5.5rem] text-zinc-950 max-w-5xl"
      >
        Technologie <span className="brand-text">verändert</span> sich.
        <br />
        Ihre IT bleibt <span className="brand-text">zuverlässig</span>.
      </motion.h2>

      <motion.p
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.7, delay: 0.15 }}
        className="mt-8 max-w-xl text-base md:text-lg text-zinc-600 leading-relaxed"
      >
        Veränderung gehört zum Alltag. Ich sorge dafür, dass Ihre IT sicher,
        stabil und zukunftsfähig bleibt – damit Sie sich auf Ihr Unternehmen
        konzentrieren können.
      </motion.p>
    </section>
  );
};
